












































import { Vue, Component, Mixins } from 'vue-property-decorator';

import MyList from '@/mixins/list';

@Component
export default class extends Mixins(MyList) {
  dispatchType = 'stadium/claims'

  columns: any[] = [
    { title: '编号', dataIndex: 'id' },
    { title: '场馆' },
    { title: '认领时间' },
    { title: '认领人' },
    { title: '状态' },
    { title: '操作', scopedSlots: { customRender: 'action' } },
  ]

  mounted() {
    this.loadData();
  }
}
